export default "__VITE_ASSET__BTUJf6eL__"